import { Dimensions } from 'react-native';

export const getWidth = () => {
	const width = Dimensions.get('screen').width;
	return width;
};
